<template>
	<div v-show="hasButton || moreMenu" class="m-detail-handle-place">
		<div class="m-detail-handle flex-between-center">
			<div>
				<c-button v-if="moreMenu" style="padding: 0 .6em;" @click="moreMenu && moreMenu.open();">更多操作<i class="tf-tri-up" style="margin-left: .05rem; font-size: .24rem;"></i></c-button>
			</div>
			<div ref="button" class="list flex-grow flex-reverse">
				<slot></slot>
			</div>
		</div>

		<slot name="more"></slot>
	</div>
</template>

<script>
	export default {
		name: 'detailHandle',
		
		data() {
			return {
				hasButton: false,
				moreMenu: null
			}
		},

		mounted() {
			this.updatedHandle();
		},

		updated() {
			this.updatedHandle();
		},

		methods: {
			updatedHandle() {
				this.$nextTick(() => {
					this.hasButton = this.$refs.button.children.length > 0;
					this.moreMenu = this.$children.find(item => item.$options.name == 'cMenu');
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-handle {
		z-index: 90;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		height: 1.2rem;
		padding: 0 .24rem var(--safe-area);
		background: #fff;
		box-shadow: 0 -.02rem 0 0 #eee;

		&-place {
			height: 1.2rem;
			padding-bottom: var(--safe-area);
		}
		
		.more {
			font-size: .3rem;
			color: #999;
		}
		
		.list {
			gap: .12rem;
		}
	}
</style>
